// removed by extract-text-webpack-plugin
module.exports = {"submittedSucess":"_2ucwbslXY8Mp2VksqrnVh-","submittedSucessTit":"_1hIfn_imMjIOUvI9UHkMQg","submittedSucessContent":"_3ndg9ZkmlyHhjg_q0-qPjG","bottom":"_1sxIefFqQ1wFLZMm9aY4_4","btn":"_2IaG89VUzT8tBET-5y12Eo"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/LogOutModal/LogOutModal.scss
 ** module id = 989
 ** module chunks = 0
 **/